/**
 * Persist the selected Steam app as workspace context so catalogue views share it.
 */
const CATALOGUE_CONTEXT_PATH_RE =
  /^\/(?:feedback-explorer|evidence-explorer|clusters|decisions|player-profiles|games|decision-surface)\/(\d+)(?:\/|$|\?)/;

export function postCatalogueContext(appId: string): void {
  const token = document
    .querySelector("meta[name='csrf-token']")
    ?.getAttribute('content');
  if (!token || !appId) return;
  fetch('/set-workspace-context', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-csrf-token': token,
    },
    body: JSON.stringify({ app_id: appId }),
    credentials: 'same-origin',
  }).catch(() => {});
}

export function persistCatalogueContextFromPath(pathname: string): void {
  const match = CATALOGUE_CONTEXT_PATH_RE.exec(pathname);
  if (match?.[1]) postCatalogueContext(match[1]);
}

/** LiveView `push_event` payloads can omit `detail`. */
function readCustomEventDetail(e: Event): unknown {
  return (e as CustomEvent<unknown>).detail;
}

/**
 * Path regex on live nav, catalogue link clicks, and `phx:set_catalogue_context`.
 */
export function bindWorkspaceContext(): void {
  document.addEventListener(
    'click',
    (e) => {
      const link = (e.target as HTMLElement).closest(
        'a[data-catalogue-game-id]'
      );
      if (!link) return;
      const appId = link.getAttribute('data-catalogue-game-id');
      if (appId) postCatalogueContext(appId);
    },
    true
  );

  persistCatalogueContextFromPath(window.location.pathname);

  window.addEventListener('phx:set_catalogue_context', (e: Event) => {
    const raw = readCustomEventDetail(e);
    if (raw === undefined || raw === null || typeof raw !== 'object') return;
    const detail = raw as { app_id?: string };
    if (!detail.app_id) return;
    postCatalogueContext(detail.app_id);
  });
}
